module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABDUlEQVQ4jc2TMUoDURRFj5MIIrEVUXvLbMEiYi9RFKzSuIMsIq2kCOgCdAGBdGI2IFgIqe0EbSwCYbzy40XGT+YTMo0XHgP333fgvccgqayOJY0lzVxjewvzZZCufjSR1HdN7HWXBR25oSepVvBr9oJay4CeJA0TIw+d+ePXgS3gCtgHGkAT2AAeWKwd4AC4AT6BV2AQaCNV1yiAckl33kHHF0pdE2c67gm9eQaEegFyYBOYloxU1NTZ3L1ZFgVOvKfLBOTCmfOiGYP2/N1NgLYLS/9VPQq1gUPgNgEaAF/AYwr07Eop7Oc6fo9HW1n/F7RegTHvXZP0BsyA+xVBZ/OjSTqV9FHhb3uX1P4GkTfKKwd44hMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/spgl.png
// module id = iDfk
// module chunks = 1